"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFallbackFunction = createFallbackFunction;
exports.resolveContextValue = resolveContextValue;
exports.safeName = safeName;
exports.generateInstanceId = generateInstanceId;
exports.generateHashOfObject = generateHashOfObject;
// import { userInfo, hostname } from 'os';
const murmurHash3 = __importStar(require("murmurhash3js"));
function createFallbackFunction(name, context, fallback) {
    if (typeof fallback === 'function') {
        return () => fallback(name, context);
    }
    if (typeof fallback === 'boolean') {
        return () => fallback;
    }
    return () => false;
}
function resolveContextValue(context, field) {
    if (context[field]) {
        return context[field];
    }
    if (context.properties && context.properties[field]) {
        return context.properties[field];
    }
    return undefined;
}
function safeName(str = '') {
    return str.replace(/\//g, '_');
}
function generateInstanceId(instanceId) {
    if (instanceId) {
        return instanceId;
    }
    // let info;
    // try {
    //   info = userInfo();
    // } catch (e) {
    //   // unable to read info;
    // }
    const prefix = `generated-${Math.round(Math.random() * 1000000)}-${process.pid}`;
    return `${prefix}-nextjs`;
}
function generateHashOfObject(o) {
    const oAsString = JSON.stringify(o);
    return murmurHash3.x86.hash128(oAsString);
}
